import { Route } from 'react-router-dom';
import routes from '../routes';
import React from 'react';

export default function useRoutes(layout = '/dashboard') {
    const layoutRoutes = routes.filter((route) => route.layout === layout);

    const getRoutes = () =>
        layoutRoutes.map((route, index) => {
            const middlewares = route.middlewares ? [...route.middlewares].reverse() : [];
            let element = <route.component />;
            middlewares.forEach((middleware) => {
                element = React.createElement(middleware, {}, element);
            });
            return <Route key={index} path={route.path} element={element} />;
        });

    const getActualRoute = () => {
        const path = window.location.pathname;
        return layoutRoutes.find((route) => `${layout}${route.path}` === path);
    };

    return {
        routes,
        getRoutes,
        getActualRoute,
        layoutRoutes,
    };
}
